<app-toolbar></app-toolbar>
<app-header [title]="'Mitarbeiter Dashboard'">
  <markant-button class="white link button" [routerLinkActive]="'primary'" [routerLink]="routes.welcome" [colorScheme]="pickedUrl('Übersicht')">
    Übersicht
  </markant-button>
  <markant-button
    *minPrivilege="'FULL'"
    class="white link button"
    [routerLinkActive]="'primary'"
    [routerLink]="routes.handelspartner"
    [colorScheme]="pickedUrl('Handelspartner')"
  >
    Handelspartner
  </markant-button>
  <markant-button
    class="white link button"
    *minPrivilege="'FULL'"
    [routerLinkActive]="'primary'"
    [routerLink]="routes.cycles"
    [colorScheme]="pickedUrl('Termine')"
  >
    Termine
  </markant-button>
  <markant-button
    class="white link button"
    [routerLinkActive]="'primary'"
    [routerLink]="routes.products"
    [queryParams]="queryParamsStartUp"
    [colorScheme]="pickedUrl('Start-ups')"
  >
    Start-ups
  </markant-button>
  <markant-button
    class="white link button"
    [routerLinkActive]="'primary'"
    [routerLink]="routes.voting"
    [queryParams]="queryParamsAbstimmung"
    [colorScheme]="pickedUrl('Abstimmung')"
  >
    Abstimmung
  </markant-button>
</app-header>
<div class="dashboard">
  <router-outlet></router-outlet>
</div>
